import { ProvisioningStatusFilter } from '@/activityLog/bulkProvisioning/constants/provisioningStatus.ts';

type ProductsManagementQueriesListProps = {
  page: number;
  pageSize: number;
  uploadDateFrom: Date | null;
  uploadDateTo: Date | null;
  status: ProvisioningStatusFilter;
  fileName: string;
};

export const productsManagementQueries = {
  all: ['ProductManagement'],
  upload: ['ProductManagement', 'upload'],
  downloadTemplate: ['ProductManagement', 'downloadTemplate'],
  listAll: () => [...productsManagementQueries.all, 'List'],
  list: (filters: ProductsManagementQueriesListProps) => [
    ...productsManagementQueries.listAll(),
    filters,
  ],
  errors: (requestId: string) => [...productsManagementQueries.all, 'Errors', requestId],
};
